import type { BrandAssets } from '@/types/roadmap.types';

export const PROVIDER_BRAND: BrandAssets = {
  logo: '/brands/bonum-funding/logo.webp',
  icon: '/brands/bonum-funding/icon.png',
  companyName: 'Bonum Funding',
  colors: {
    primary: '#1c3459',
    secondary: '#040404',
  },
};
